import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ComponentContext } from 'src/app/modules/modal/modal.model';

@Component({
  selector: 'gcc-did-solve-issue',
  templateUrl: './did-solve-issue.component.html',
  styleUrls: ['./did-solve-issue.component.scss']
})
export class DidSolveIssueComponent implements ComponentContext<any> {
  @Input() public questionTitle: string;
  @Input() public onAction: (value: any) => void;
  @Input() public onClose: () => void;

  public onCloseSurvey(): void {
    this.onClose();
    this.onAction(false);
  }

  public onLike(): void {
    this.onAction('like');
    this.onClose();
  }

  public onDislike(): void {
    this.onAction('dislike');
    this.onClose();
  }
}
